/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_NoInputs */

const fr_admin_subscription_rights_no = /** @type {(inputs: Admin_Subscription_Rights_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

/**

* @param {Admin_Subscription_Rights_NoInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_no = /** @type {((inputs?: Admin_Subscription_Rights_NoInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_NoInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_no(inputs)
});